jQuery( document ).ready( function ( $ ) {
	function GROUP( thisInstance ) {
		console.log( '[JTF Gut Block - JS] jtf/jtf-group v1.0' )
		this.instance = thisInstance
		this.init()
	}

	GROUP.prototype.init = function () {
		const self = this

		// Animated block
		if ( this.instance.hasClass( "jtf__animation" ) ) {
			// Uses IntersectionObserver API:
			// https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API

			let options = {
				root: null,
			}

			let observer = new IntersectionObserver( self.ioCallbackFunc, options )
			observer.observe( this.instance[ 0 ] )
		}
	}

	GROUP.prototype.ioCallbackFunc = function ( entries, observer ) {
		entries.forEach( ( entry ) => {
			// Get the animation type from the html
			const animation = 'jtf__animation__' + $( entry.target ).attr( 'data-animation' )

			if ( true == entry.isIntersecting ) {
				// Animate if in view
				$( entry.target ).addClass( animation )
			}
		} )
	}

	setTimeout( function () {
		// Check GROUP is used on this page before instantiating
		if ( $( '.wp-block-jtf-jtf-group' ).length > 0 ) {
			$( '.wp-block-jtf-jtf-group' ).each( function () {
				new GROUP( $( this ) )
			} )
		}
	}, 1000 )
} )
